import type { RequestCorrelationContext } from "./client";

interface OptionsAffectingHeaders {
    serverVersion: string | undefined;
    requestBody: undefined | string | FormData;
    method: string;
    correlationContext: RequestCorrelationContext;
    getAntiForgeryToken: () => string | null;
    accept?: string;
}

export function requestHeaders(options: OptionsAffectingHeaders) {
    const { method, methodOverride } = getMethod(options.method);
    const headers = new Headers();

    headers.set("X-Octopus-User-Agent", "OctopusClient-js/" + options.serverVersion);

    headers.set("Accept", options.accept ?? "application/json");

    if (options.requestBody && !isFormData(options.requestBody)) {
        headers.set("Content-type", "application/json");
    }

    if (methodOverride) {
        headers.set("X-HTTP-Method-Override", methodOverride);
    }

    // Set X-Octopus-Csrf-Token header if there is an antiforgery cookie available and it"s a mutating request
    if (method === "POST" || method === "PUT" || method === "DELETE") {
        const antiforgeryToken = options.getAntiForgeryToken();
        if (antiforgeryToken) {
            headers.set("X-Octopus-Csrf-Token", antiforgeryToken);
        }
    }

    Object.entries(options.correlationContext).forEach(([name, value]) => {
        headers.set(`X-Context-${name}`, value);
    });

    return headers;
}

export function getMethod(method: string): { method: string; methodOverride: string | undefined | null } {
    let methodOverride: string | null = null;
    if (method === "PUT") {
        methodOverride = "PUT";
        method = "POST";
    }
    if (method === "DELETE") {
        methodOverride = "DELETE";
        method = "POST";
    }
    return { method, methodOverride };
}

function isFormData(item: {}): boolean {
    return item instanceof FormData;
}
